import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

class CheckIn extends React.Component {
  state = { loading: false, latitude: null, longitude: null };

  latitude = null;
  longitude = null;

  componentWillMount() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(location => {
        this.latitude = location.coords.latitude;
        this.longitude = location.coords.longitude;
        console.log(location);
      });
    }
  }

  handleCheckIn = () => {
    const { onDone } = this.props;
    const data = {
      check_in_lat: this.latitude,
      check_in_long: this.longitude
    };

    this.setState({ loading: true });
    axios.put(`${window.location.pathname}/employees/checking_in`, data)
      .then(({ data }) => {
        this.setState({ loading: false });
        toastr.success(data.message);
        onDone(data.check_in_at);
      })
      .catch(({ response }) => {
        this.setState({ loading: false });

        if (response && response.data && response.data.message) {
          toastr.error(response.data.message);
        }
      })
    ;
  };

  render() {
    const { loading } = this.state;

    return (
      <div className="well shadowDepth1 employees">
        <div className="text-center" style={{ paddingTop: 80, paddingBottom: 80 }}>
          <button
            disabled={loading}
            className="btn btn-indigo btn-raised btn-long"
            onClick={this.handleCheckIn}
          >
            CHECK{loading ? "ING.."  : ""} IN
          </button>
        </div>
      </div>
    );
  }
}

CheckIn.propTypes = {
  onDone: PropTypes.func
};

export default CheckIn;
